import { FotClientAdapter } from "../api/FotClientAdapter";
import { FoodApi } from "../api/FoodApi";
import { GraphqlClient } from "../cutil/GraphqlClient";
import { RestClient } from "../cutil/RestClient";
import { StreamClient } from "../cutil/StreamClient";
import { MapApi } from "./MapApi";
import { CotApi } from "./CotApi";
import { JiraAPI } from "./JiraApi";
import { GeneralApi } from "./GeneralApi";
import { WebConfigAPI } from "./WebConfigAPI";
import { settings } from "../kernel/Settings";
export class FotClient {
    constructor(authStore, projectStore, locationManager) {
        this.authStore = authStore;
        this.projectStore = projectStore;
        this.locationManager = locationManager;
        const restClientAdapter = new FotClientAdapter(settings.API, authStore, projectStore);
        this.restClient = new RestClient(restClientAdapter);
        const graphqlClientAdapter = new FotClientAdapter(settings.API + "/api/social/", authStore, projectStore);
        this.graphqlClient = new GraphqlClient(graphqlClientAdapter);
        const streamClientAdapter = new FotClientAdapter(settings.API, authStore, projectStore);
        this.streamClient = new StreamClient(streamClientAdapter);
        const jiraRestClientAdapter = new FotClientAdapter("", authStore, projectStore);
        this.jiraRestClient = new RestClient(jiraRestClientAdapter);
    }
    get generalApi() {
        return new GeneralApi(this.restClient);
    }
    get cot() {
        return new CotApi(this.restClient);
    }
    get foodApi() {
        return new FoodApi(this.restClient, this.locationManager);
    }
    get map() {
        return new MapApi(this.restClient);
    }
    get jira() {
        return new JiraAPI(this.jiraRestClient);
    }
    get webConfigApi() {
        return new WebConfigAPI();
    }
}
